import React, { useState } from "react";
import { Card, Typography } from "antd";
import { CitationData } from "./CitationsResults.hook";

const { Text } = Typography;

interface CitationCardProps {
    citation: CitationData;
}

export const CitationCard: React.FC<CitationCardProps> = ({ citation }) => {
    const [isExpanded, setIsExpanded] = useState(true); // Start expanded by default
    
    if (!citation?.html_description) {
        return null;
    }

    // Check if text is much longer than a normal card (increased threshold)
    const plainText = citation.html_description.replace(/<[^>]*>/g, '');
    const isVeryLongText = plainText.length > 800; // Much higher threshold - only for very long content
    const shouldTruncate = isVeryLongText && !isExpanded;

    // Better HTML truncation that tries to preserve word boundaries
    const truncatedHtml = shouldTruncate 
        ? (() => {
            const truncatedText = plainText.substring(0, 600); // Show more content before truncating
            const lastSpaceIndex = truncatedText.lastIndexOf(' ');
            const cutPoint = lastSpaceIndex > 500 ? lastSpaceIndex : 600;
            return citation.html_description.substring(0, cutPoint) + '...';
        })()
        : citation.html_description;

    return (
        <div style={{
            padding: "16px",
            backgroundColor: "#fff",
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            fontSize: "14px",
            lineHeight: "1.6",
            color: "#333",
            marginBottom: "0" // Explicitly remove margin bottom
        }}>
            <h3 style={{
                margin: "0 0 12px 0",
                fontSize: "18px",
                fontWeight: "600",
                color: "#333"
            }}>
                Tendencia de vivienda
            </h3>
            
            <div 
                dangerouslySetInnerHTML={{ __html: shouldTruncate ? truncatedHtml : citation.html_description }}
                style={{
                    fontSize: "14px",
                    lineHeight: "1.6",
                    color: "#333",
                    margin: "0", // No margins
                    padding: "0" // No padding
                }}
            />
            
            {isVeryLongText && (
                <div style={{ marginTop: "8px", marginBottom: "0" }}>
                    <button
                        onClick={() => setIsExpanded(!isExpanded)}
                        style={{
                            fontSize: "12px",
                            color: "#007bff",
                            textDecoration: "none",
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            padding: 0,
                            margin: 0
                        }}
                    >
                        {isExpanded ? 'Ver menos' : 'Ver más'}
                    </button>
                </div>
            )}
        </div>
    );
};
